import { render, staticRenderFns } from "./WithHeader.vue?vue&type=template&id=64d2d314&"
import script from "./WithHeader.vue?vue&type=script&lang=ts&"
export * from "./WithHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports